import { ReactNode } from 'react';
import { Navigate } from 'hotel/navigation';

import { useUserRole } from '../hooks/useUserRole';

type AdminOnlyRouteProps = {
  children: ReactNode;
  redirectTo?: string;
};

/**
 * AdminOnlyRoute restricts access to admin/user roles only.
 * Pure travelers (without elevated roles) are redirected away.
 *
 * @example
 * <Route
 *   path="admin-feature/*"
 *   element={
 *     <AdminOnlyRoute redirectTo="/dashboard">
 *       <AdminFeature />
 *     </AdminOnlyRoute>
 *   }
 * />
 */
export const AdminOnlyRoute = ({
  children,
  redirectTo = '/dashboard',
}: AdminOnlyRouteProps) => {
  // Use isOnlyTraveler to allow users with both traveler and admin/user roles
  const { isOnlyTraveler } = useUserRole();

  if (isOnlyTraveler) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default AdminOnlyRoute;
